module.exports = __webpack_public_path__ + "img/img2.020b1bbd.jpg";